'use client';

import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@kit/ui/dialog';
import { cn } from '@kit/ui/utils';

import { useBookingPresentation } from './booking-presentation';

interface CheckoutSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onViewBookings?: () => void;
}

export function CheckoutSuccessDialog({
  isOpen,
  onClose,
  onViewBookings,
}: CheckoutSuccessDialogProps) {
  const presentation = useBookingPresentation();
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        {...presentation}
        className={cn('max-w-md', presentation.className)}
      >
        <div className="space-y-4 text-center">
          <div className="flex justify-center">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>

          <DialogHeader>
            <DialogTitle>{t('bookings:bookingConfirmedTitle')}</DialogTitle>
          </DialogHeader>

          <p className="text-muted-foreground">
            {t('bookings:bookingConfirmedBody')}
          </p>

          <div className="flex flex-col gap-2">
            {onViewBookings && (
              <Button onClick={onViewBookings}>
                {t('bookings:viewMyBookings')}
              </Button>
            )}
            <Button variant="outline" onClick={onClose}>
              {t('bookings:continueBrowsing')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
